import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { Button } from 'formlabs-web-components/Link';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Picture } from 'formlabs-web-components/Media';
import './webinars.module.css';
import whiteIcon from '../../../../public/play_white.svg';

const FeaturedWebinar = DisplayComponent(
  class FeaturedWebinar extends PureComponent {
    render() {
      const { title, image, date, ctaText, webinarURL, live, t } = this.props;
      const liveFlag = <span styleName="live">{t('live')}</span>;

      return (
        <Grid direction="x">
          <Cell
            classes="home-featured-news"
            backgroundColor="blue"
            largeSize={12}
            mediumSize={12}
          >
            <p styleName="featured-date">
              {live && liveFlag} {date}
            </p>
            <Header level={4} displayAs={4} weight={400}>
              {title}
            </Header>
            <br />
            <Button color="white" url={webinarURL}>
              <div styleName="button-fix">
                <Picture largeImage={whiteIcon} alt={t('youtube play icon')} />
                {ctaText}
              </div>
            </Button>
          </Cell>
          <Cell largeSize={12} mediumSize={12}>
            <Picture alt={title} fullBleed={true} largeImage={image} />
          </Cell>
        </Grid>
      );
    }
  }
);

export default withTranslation()(FeaturedWebinar);
